import { IPV4_REGEX } from '@kentik/ui-shared/util/regex';

export default {
  fn: (value) => {
    if (!value || typeof value !== 'string') {
      return false;
    }
    return value && typeof value === 'string' && value.match(IPV4_REGEX);
  },
  message: 'Enter a valid IPv4 address. '
};
